// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"470px","pageContainer":"works_pageContainer__15TPi","galleryContainer":"works_galleryContainer__elyF6","galleryTile":"works_galleryTile__3VUi5"};